// Function to merge PDF Blob and Base64 image
import {ASSETS_PATH} from "../../constants/dashboard";

export const mergePdfWithSignature = async (pdfBlob, base64Image, withText = true) => {
  // Convert Blob to ArrayBuffer
  const pdfArrayBuffer = await pdfBlob.arrayBuffer();

  // Load the existing PDF
  const pdfDoc = await window.PDFDocument.load(pdfArrayBuffer);

  //Add font kit to the project

  if (withText) {
    pdfDoc.registerFontkit(window.PDFDocumentFontkit); // optional!
  }

  // Decode the Base64 image and embed it
  const imageBytes = Uint8Array.from(atob(base64Image.split(',')[1]), c => c.charCodeAt(0));
  const image = await pdfDoc.embedPng(imageBytes); // or use embedJpg if it's a JPEG

  // Get the first page of the PDF
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];

  // Define image placement (adjust these values)
  const { width, height } = firstPage.getSize();
  const imgWidth = 160;  // Adjust based on your needs
  const imgHeight = 50;  // Adjust based on your needs
  const x = width - imgWidth - 50; // Position from right
  const y = 50; // Position from bottom

  // Draw the image on the page
  firstPage.drawImage(image, {
    x,
    y,
    width: imgWidth,
    height: imgHeight,
  });

  if (withText) {
    // Fetch the custom font
    const playRegularFontUrl = ASSETS_PATH + "/fonts/play-regular.ttf";
    // const playBoldFontUrl = ASSETS_PATH + "/fonts/play-bold.ttf";
    const playRegularFontBytes = await fetch(playRegularFontUrl).then(res => res.arrayBuffer());
    // const playBoldFontBytes = await fetch(playRegularFontUrl).then(res => res.arrayBuffer());

    // Embed the custom font
    const playRegularFont = await pdfDoc.embedFont(playRegularFontBytes);
    // const playBoldFont = await pdfDoc.embedFont(playBoldFontBytes);

    // Draw the text on the page
    firstPage.drawText("Some Awesome Text", {
      x: 70,    // X position (adjust as needed)
      y: 503,    // Y position (adjust as needed)
      size: 13,  // Font size
      font: playRegularFont,
      color: window.PDFDocumentRGB(0.29, 0.565, 0.886), // Blue text
    });
  }

  // firstPage.drawLine({
  //   start: { x: x1, y: y1 },
  //   end: { x: x2, y: y2 },
  //   thickness: 2, // Line thickness
  //   color: rgb(1, 0, 0), // Red color
  // });

  // Save the modified PDF
  const modifiedPdfBytes = await pdfDoc.save();

  // Convert back to Blob
  return new Blob([modifiedPdfBytes], { type: 'application/pdf' });
}
